export class DialogRemoveMedConfirm{
    constructor(
      public medicine: any
    ) {}
  }
  